/**
 * ユーザー行動のイベント名・プロパティ名ラベル定義
 * i18n.ts から分離（変更頻度が低い大規模定義のため）
 *
 * @graph-stack ux-mirror
 * @graph-domain UX
 * @graph-business ユーザー行動イベント名/プロパティ名の日英ラベル定義。80+イベント名と240+プロパティ名の翻訳マッピング
 */

/**
 * @graph-stack ux-mirror
 * @graph-domain UX
 * @graph-business ユーザー行動イベント名の日本語ラベルを定義する
 * @graph-connects none
 */
export const jaUserEventNames = {
  screen_rendered: '画面表示',
  identity_linked: 'ログイン紐付け',
  field_hesitation: '入力躊躇',
  form_field_state: 'フォーム入力状態',
  form_exit_snapshot: 'フォーム離脱時状態',
  item_tapped: 'アイテムタップ',
  buy_button_clicked: '購入ボタンクリック',
  buying_modal_opened: '購入モーダル表示',
  purchase_completed: '購入完了',
  bulk_purchase_completed: '一括購入完了',
  home_item_availability: 'ホーム在庫状況',
  rental_item_detail: 'レンタルアイテム詳細',
  rental_item_details: 'レンタルアイテム詳細',
  change_option: 'オプション変更',
  change_plan: 'プラン変更',
  plan_selected: 'プラン選択',
  course_selected: 'コース選択',
  confirm_modal_opened: '確認モーダル表示',
  plan_change_confirmed: 'プラン変更完了',
  stylist_designation: 'スタイリスト指名',
  return_procedure: '返却手続き',
  return_step: '返却方法選択',
  return_method_selected: '返却方法決定',
  return_service: '返却サービス',
  return_completed: '返却完了',
  next_request: '次回リクエスト',
  request_submitted: 'リクエスト送信',
  reg_introduction: '登録導入',
  reg_nickname: 'ニックネーム入力',
  reg_qa_questions: '診断質問',
  answer_selected: '回答選択',
  reg_diagnosis_result: '診断結果',
  reg_style: 'スタイル選択',
  reg_lifestyle: 'ライフスタイル入力',
  reg_size: 'サイズ入力',
  reg_ng: 'NGファッション選択',
  reg_request: 'スタイリングリクエスト',
  reg_plan: 'プラン選択（登録）',
  coupon_applied: 'クーポン適用',
  payment_method_selected: '支払方法選択',
  registration_submitted: '登録完了',
  reg_add_options: 'オプション追加',
  reg_thank_you: '登録完了画面',
  step_completed: 'ステップ完了',
  cancel_step1: '解約開始',
  cancel_step2: '違約金確認',
  policy_checkbox_toggled: '同意チェック',
  cancel_step3: '解約アンケート',
  questionnaire_answered: 'アンケート回答',
  cancel_step4: '解約最終確認',
  cancel_confirmed: '解約確定',
  cancel_done: '解約完了',
  diagnosis_lp: '診断LP',
  diagnosis_nickname: '診断ニックネーム',
  diagnosis_color: 'カラー診断',
  diagnosis_skeleton: '骨格診断',
  diagnosis_self_image: 'セルフイメージ',
  diagnosis_salon: 'サロン質問',
  diagnosis_result: '診断結果',
  diagnosis_completed: '診断完了',
  share_twitter: 'Twitter共有',
  share_facebook: 'Facebook共有',
  download_result: '結果ダウンロード',
  login_modal: 'ログインモーダル',
  modal_opened: 'モーダル表示',
  modal_closed: 'モーダル閉じ',
  login_attempted: 'ログイン試行',
  login_succeeded: 'ログイン成功',
  login_failed: 'ログイン失敗',
  home_current_box: 'ホーム（現在のBOX）',
  my_closet: 'マイクローゼット',
  album: 'アルバム',
  item_purchase: 'アイテム購入',
  webview_opened: 'WebView表示',
  prime: 'プライム',
};

/**
 * @graph-stack ux-mirror
 * @graph-domain UX
 * @graph-business ユーザー行動プロパティ名の日本語ラベルを定義する
 * @graph-connects none
 */
export const jaUserPropNames = {
  membership_status: '会員ステータス',
  plan_id: 'プランID',
  rental_status: 'レンタルステータス',
  payment_type: '支払方法',
  option_ids: 'オプションID',
  is_come_back: '復帰ユーザー',
  is_waiting: 'ウェイティング中',
  prefecture: '都道府県',
  has_reserved_plan: 'プラン予約あり',
  previous_screen: '前の画面',
  dwell_time_ms: '滞在時間(ms)',
  exit_reason: '離脱理由',
  item_id: 'アイテムID',
  item_sku_id: 'SKU ID',
  delivery_id: '配送ID',
  rental_id: 'レンタルID',
  is_current_item: '現在のアイテム',
  buy_type: '購入タイプ',
  is_buyable: '購入可能',
  is_sold_out: '売り切れ',
  is_purchased: '購入済み',
  is_out_of_stock: '在庫切れ',
  is_new_item: '新着アイテム',
  has_new_item: '新着あり',
  new_item_is_buyable: '新着購入可能',
  new_item_is_purchased: '新着購入済み',
  diff_colors: '色違い数',
  is_diff_color: '色違い',
  price: '価格',
  retail_price: '定価',
  sale_discount: 'セール割引',
  coupon_discount: 'クーポン割引',
  sharing_discount: 'シェア割引',
  used_point: '使用ポイント',
  tax: '税額',
  postage: '送料',
  total: '合計',
  item_rank_type: 'アイテムランク',
  brand_name: 'ブランド名',
  is_free: '無料',
  double_box: 'ダブルBOX',
  accessory: 'アクセサリー',
  one_select: 'ワンセレクト',
  brand_option: 'ブランドオプション',
  occasion_option: 'オケージョンオプション',
  is_disabled_all: '全オプション無効',
  is_able_to_accessory: 'アクセサリー利用可',
  is_able_to_one_select: 'ワンセレクト利用可',
  is_double_box_available: 'ダブルBOX利用可',
  is_doublebox_user: 'ダブルBOXユーザー',
  is_one_select_user: 'ワンセレクトユーザー',
  is_brand_option: 'ブランドオプション',
  is_occasion_option: 'オケージョンオプション',
  current_plan_id: '現在のプランID',
  current_payment_type: '現在の支払方法',
  new_plan_id: '新プランID',
  new_months: '新コース月数',
  has_pending_plan_change: 'プラン変更予約あり',
  has_pending_course_change: 'コース変更予約あり',
  disabled_plan_ids: '選択不可プラン',
  selectable_plan_ids: '選択可能プラン',
  is_np_user: 'NP後払いユーザー',
  is_settlement_date_today: '決済日（本日）',
  is_course_user: 'コースユーザー',
  is_penalty: '違約金あり',
  penalty_fee: '違約金額',
  contract_month: '契約月数',
  months: 'コース月数',
  is_locked: 'ロック中',
  send_back_method: '返却方法',
  has_last_send_back_method: '前回返却方法あり',
  last_send_back_method: '前回の返却方法',
  can_return_on_sagawa: '佐川で返却可',
  is_return_indicator_shown: '返却インジケーター表示',
  return_deadline: '返却期限',
  has_double_return: 'ダブル返却',
  has_existing_request: '既存リクエストあり',
  has_usage_scene: '利用シーンあり',
  has_sleeve_length: '袖丈指定あり',
  has_life_style: 'ライフスタイルあり',
  show_indicator: 'インジケーター表示',
  has_feedback: 'フィードバックあり',
  usage_scene: '利用シーン',
  has_next_request: '次回リクエストあり',
  sleeve_length: '袖丈',
  has_designated_stylist: '指名スタイリストあり',
  designated_stylist_id: '指名スタイリストID',
  stylist_count: 'スタイリスト数',
  has_current_stylist: '現在のスタイリストあり',
  is_premium: 'プレミアム',
  box_count: 'BOX数',
  has_unreturned_box: '未返却BOXあり',
  has_receipt_box: '受取BOXあり',
  is_apply_cancel: '申込キャンセル',
  is_one_select_time: 'ワンセレクトタイム',
  item_count: 'アイテム数',
  total_items: '合計アイテム数',
  is_empty: '空',
  is_recommend_enabled: 'レコメンド有効',
  has_category_filter: 'カテゴリフィルターあり',
  has_color_filter: 'カラーフィルターあり',
  wearing_item_count: '着用アイテム数',
  is_first_delivery: '初回配送',
  has_banner: 'バナーあり',
  field: 'フィールド',
  hesitation_ms: '躊躇時間(ms)',
  filled_fields: '入力済みフィールド',
  empty_fields: '未入力フィールド',
  filled_count: '入力済み数',
  total_count: '合計数',
  completion_rate: '完了率',
  last_field: '最後のフィールド',
  required_filled_count: '必須入力済み数',
  required_total_count: '必須合計数',
  nickname: 'ニックネーム',
  question_id: '質問ID',
  question_number: '質問番号',
  answer: '回答',
  answered_count: '回答数',
  selected_index: '選択インデックス',
  selected_answer: '選択した回答',
  selected_values: '選択値',
  color_point: 'カラーポイント',
  color_type: 'カラータイプ',
  skeleton_type: '骨格タイプ',
  self_image_type: 'セルフイメージタイプ',
  is_guest: 'ゲスト',
  step_name: 'ステップ名',
  step_number: 'ステップ番号',
  favorite_coordinates: 'お気に入りコーデ',
  group_taste: 'グループテイスト',
  occupation: '職業',
  height: '身長',
  bust: 'バスト',
  pants_size: 'パンツサイズ',
  skirt_size: 'スカートサイズ',
  ng_tag_count: 'NGタグ数',
  has_coupon: 'クーポンあり',
  coupon_code: 'クーポンコード',
  success: '成功',
  type: 'タイプ',
  has_diagnosed: '診断済み',
  package_month: 'パッケージ月数',
  depth_percent: 'スクロール深度(%)',
  apply_cancel_date: '退会申請日',
  can_use_karte_consulting: 'カルテ相談利用可',
  current_option_ids: '現在のオプションID',
  is_apply_cancel_prime_option: 'プライムオプション解約申請中',
  is_applying_np: 'NP後払い申請中',
  is_applying_options: 'オプション申請中',
  is_prime_option: 'プライムオプション',
  is_reserved_plan: '予約中プランあり',
  rental_count: 'レンタル回数',
  repeat_count: '月額会員登録回数',
  reserved_option_ids: '予約オプションID',
  settlement_date: '決済日',
  tops_size: 'トップスサイズ',
  ui_pattern_id: 'UIパターンID',
  source: 'ソース',
  path: 'パス',
  method: 'メソッド',
  error_message: 'エラーメッセージ',
};

/**
 * @graph-stack ux-mirror
 * @graph-domain UX
 * @graph-business ユーザー行動イベント名の英語ラベルを定義する
 * @graph-connects none
 */
export const enUserEventNames = {
  screen_rendered: 'Screen Rendered',
  identity_linked: 'Identity Linked',
  field_hesitation: 'Field Hesitation',
  form_field_state: 'Form Field State',
  form_exit_snapshot: 'Form Exit Snapshot',
  item_tapped: 'Item Tapped',
  buy_button_clicked: 'Buy Button Clicked',
  buying_modal_opened: 'Buying Modal Opened',
  purchase_completed: 'Purchase Completed',
  bulk_purchase_completed: 'Bulk Purchase Completed',
  home_item_availability: 'Home Item Availability',
  rental_item_detail: 'Rental Item Detail',
  rental_item_details: 'Rental Item Details',
  change_option: 'Change Option',
  change_plan: 'Change Plan',
  plan_selected: 'Plan Selected',
  course_selected: 'Course Selected',
  confirm_modal_opened: 'Confirm Modal Opened',
  plan_change_confirmed: 'Plan Change Confirmed',
  stylist_designation: 'Stylist Designation',
  return_procedure: 'Return Procedure',
  return_step: 'Return Step',
  return_method_selected: 'Return Method Selected',
  return_service: 'Return Service',
  return_completed: 'Return Completed',
  next_request: 'Next Request',
  request_submitted: 'Request Submitted',
  reg_introduction: 'Registration Intro',
  reg_nickname: 'Nickname Entry',
  reg_qa_questions: 'Diagnosis Questions',
  answer_selected: 'Answer Selected',
  reg_diagnosis_result: 'Diagnosis Result',
  reg_style: 'Style Selection',
  reg_lifestyle: 'Lifestyle Entry',
  reg_size: 'Size Entry',
  reg_ng: 'NG Fashion Selection',
  reg_request: 'Styling Request',
  reg_plan: 'Plan Selection (Reg)',
  coupon_applied: 'Coupon Applied',
  payment_method_selected: 'Payment Method Selected',
  registration_submitted: 'Registration Completed',
  reg_add_options: 'Add Options',
  reg_thank_you: 'Thank You Page',
  step_completed: 'Step Completed',
  cancel_step1: 'Cancel Start',
  cancel_step2: 'Penalty Check',
  policy_checkbox_toggled: 'Policy Checkbox',
  cancel_step3: 'Cancel Survey',
  questionnaire_answered: 'Survey Answered',
  cancel_step4: 'Cancel Final Confirm',
  cancel_confirmed: 'Cancel Confirmed',
  cancel_done: 'Cancel Done',
  diagnosis_lp: 'Diagnosis LP',
  diagnosis_nickname: 'Diagnosis Nickname',
  diagnosis_color: 'Color Diagnosis',
  diagnosis_skeleton: 'Skeleton Diagnosis',
  diagnosis_self_image: 'Self Image',
  diagnosis_salon: 'Salon Question',
  diagnosis_result: 'Diagnosis Result',
  diagnosis_completed: 'Diagnosis Completed',
  share_twitter: 'Share Twitter',
  share_facebook: 'Share Facebook',
  download_result: 'Download Result',
  login_modal: 'Login Modal',
  modal_opened: 'Modal Opened',
  modal_closed: 'Modal Closed',
  login_attempted: 'Login Attempted',
  login_succeeded: 'Login Succeeded',
  login_failed: 'Login Failed',
  home_current_box: 'Home (Current Box)',
  my_closet: 'My Closet',
  album: 'Album',
  item_purchase: 'Item Purchase',
  webview_opened: 'WebView Opened',
  prime: 'Prime',
};

/**
 * @graph-stack ux-mirror
 * @graph-domain UX
 * @graph-business ユーザー行動プロパティ名の英語ラベルを定義する
 * @graph-connects none
 */
export const enUserPropNames = {
  membership_status: 'Membership Status',
  plan_id: 'Plan ID',
  rental_status: 'Rental Status',
  payment_type: 'Payment Type',
  option_ids: 'Option IDs',
  is_come_back: 'Comeback User',
  is_waiting: 'Waiting',
  prefecture: 'Prefecture',
  has_reserved_plan: 'Has Reserved Plan',
  dwell_time_ms: 'Dwell Time (ms)',
  exit_reason: 'Exit Reason',
  item_id: 'Item ID',
  item_sku_id: 'SKU ID',
  delivery_id: 'Delivery ID',
  rental_id: 'Rental ID',
  is_current_item: 'Current Item',
  buy_type: 'Buy Type',
  is_buyable: 'Buyable',
  is_sold_out: 'Sold Out',
  is_purchased: 'Purchased',
  is_out_of_stock: 'Out of Stock',
  is_new_item: 'New Item',
  price: 'Price',
  total: 'Total',
  field: 'Field',
  hesitation_ms: 'Hesitation (ms)',
  filled_count: 'Filled Count',
  total_count: 'Total Count',
  completion_rate: 'Completion Rate',
  error_message: 'Error Message',
  source: 'Source',
  type: 'Type',
  success: 'Success',
};
